




































import { Vue, Component, Prop } from 'vue-property-decorator';
import { EAuthenticationStepType } from '@signing-page/authentication/types/enums/authentication-step-type';
import type { IAuthenticationStep } from '@signing-page/authentication/types/authentication-step';
import Pin from '@signing-page/common/components/Pin.vue';

@Component({
  components: {
    Pin,
  },
})
export default class Sms extends Vue {
  @Prop() authStep: IAuthenticationStep;
  @Prop() isCorrectPin?: boolean;
  @Prop() submittingResponse: boolean;

  pin = '';
  hasSentPin = false;
  pinLength = 6;

  get description(): string {
    return `${this.$t('sms-auth-description')} ${this.lastFourDigits}.`;
  }

  get infoText(): string {
    return `${this.$t('sms-info-text')} ${this.lastFourDigits}.`;
  }

  get lastFourDigits(): string {
    return this.authStep.data.mobile;
  }

  get disableValidate(): boolean {
    return this.pin.length !== this.pinLength;
  }

  get wrongPin(): boolean {
    return this.isCorrectPin === false;
  }

  get codeSent(): boolean {
    return this.hasSentPin && !this.wrongPin;
  }

  handlePin(pin: string) {
    this.pin = pin;
  }

  sendPin() {
    this.hasSentPin = true;
    this.$emit('sendPin');
  }

  handleAnswer() {
    this.$emit('answer', { type: EAuthenticationStepType.VerifySms, value: this.pin });
  }

  bindEnter({ key }: KeyboardEvent) {
    if (key === 'Enter') {
      this.handleAnswer();
    }
  }

  mounted() {
    document.addEventListener('keydown', this.bindEnter);
  }

  beforeDestroy() {
    document.removeEventListener('keydown', this.bindEnter);
  }
}
